import React from 'react';
import { Outlet } from 'react-router-dom';
import CustomAdminAppBar from '../../Components/AppBar/CustomAdminAppBar';
import { ToastContainer } from 'react-toastify';
// import AdminAppBar from '../components/AdminAppBar'; // your admin-specific app bar

const AdminLayout = ({dynamicLogo}) => {
  return (
    <>
      <CustomAdminAppBar dynamicLogo={dynamicLogo}/>
      <main>
        <Outlet />
      </main>
      {/* <ToastContainer
        position="top-right"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      /> */}
    </>
  );
};

export default AdminLayout;
